<template>
  <div class="services-section pricing-policy">
    <LayoutSection size="o5v90">
      <PreviousPageBtn :label-code="previoueBtnName" :class="'mt-40'" />
      <el-row>
        <el-col class="text-left p-9" :xs="12" :sm="8" :md="8">
          <div class="bg-accent-light text-center p-20 mt-15">
            <img :src="servicesImage" class="services-image" />
          </div>
        </el-col>
        <el-col class="text-left p-9 faq-tile" :xs="12" :sm="16" :md="16">
          <h2 class="mb-13 text-left page-title mt-150">
            {{ $t("faq.pricingPolicy.title") }}
          </h2>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="12" :sm="13" :md="13" :offset="5" class="mt-50">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="pricingPolicy in pricingPolicyQuestion"
              :key="pricingPolicy.question"
              :title="pricingPolicy.question"
              :name="pricingPolicy.question"
            >
              <div v-html="pricingPolicy.answer" class="text-left answer"></div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </LayoutSection>
  </div>
</template>

<script>
import LayoutSection from "@/components/layout/layout-section.vue";
import PreviousPageBtn from "@/components/previous-page-btn.vue";

export default {
  components: {
    LayoutSection,
    PreviousPageBtn,
  },
  data() {
    return {
      previoueBtnName: "FrequentlyAskedQuestions",
      activeNames: [""],
      tabActiveName: "first",
    };
  },
  computed: {
    servicesImage() {
      return require("@/assets/images/faq/services/services.png");
    },
    pricingPolicyQuestion() {
      return this.$i18n.t("faq.pricingPolicy.pricingPolicy");
    },
  },
  methods: {},
};
</script>

<style>
.services-section {
  margin-bottom: 50px;
}
.services-image {
  height: auto;
  width: 100%;
}
.faq-tile-desscription {
  margin-top: 10px;
}
.services-tile-title {
  font-size: 18px;
  font-weight: bold;
}
.el-collapse-item__header {
  font-size: 20px;
}
.answer {
  font-size: 15px;
}
.el-collapse {
  border-top: 0;
}
.page-title {
  font-size: 60px;
}
</style>
